export default __webpack_public_path__ + "static/media/jawalat2.c7ed1ef0.png";